import { useState, useEffect, useCallback } from 'react';
import { MetaPixel } from '../utils/metaPixel';

const CART_KEY = 'gospeleon_cart';

function loadCart() {
  try {
    return JSON.parse(localStorage.getItem(CART_KEY)) || [];
  } catch {
    return [];
  }
}

function saveCart(items) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
}

export function useCart() {
  const [items, setItems] = useState(loadCart);

  useEffect(() => {
    saveCart(items);
  }, [items]);

  const addItem = useCallback((item) => {
    setItems(prev => {
      if (prev.some(i => i.item_id === item.item_id)) return prev;
      const newItem = {
        item_id: item.item_id || item.album_id || item.track_id,
        item_type: item.item_type || (item.album_id ? 'album' : item.is_single ? 'single' : 'track'),
        title: item.title,
        artist_name: item.artist_name || item.artist?.name || '',
        cover_art: item.cover_art || '',
        price: parseFloat(item.price) || 0,
      };
      MetaPixel.addToCart(newItem);
      return [...prev, newItem];
    });
  }, []);

  const removeItem = useCallback((itemId) => {
    setItems(prev => prev.filter(i => i.item_id !== itemId));
  }, []);

  const clearCart = useCallback(() => {
    setItems([]);
  }, []);

  const isInCart = useCallback((itemId) => {
    return items.some(i => i.item_id === itemId);
  }, [items]);

  const total = items.reduce((sum, i) => sum + (i.price || 0), 0);

  return { items, addItem, removeItem, clearCart, isInCart, total, count: items.length };
}
